import React, { useState } from 'react';
import DTOLetterRequestARModal from './DTOLetterRequestARModal';
import LetterRequestARModalPresenter from './LetterRequestARModalPresenter';
import { useTranslation } from 'react-i18next';
import { actionRequiredService } from '../../../../api/services/actionRequiredService';
import { useAppSelector } from '../../../../infra/hooks';
import toast from 'react-hot-toast';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;

  fullData?: any;
}

const LetterRequestARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const [daActions, setDaActions] = useState([]);
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == 'success') {
          toast.success('Action Performed Successfully!');
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOLetterRequestARModal
        setAllActions={(act: any) => setDaActions(act)}
      />

      <LetterRequestARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        allActions={daActions}
        fullData={fullData}
        userId={selector.user_id}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default LetterRequestARModalController;
